import classes from "./pagnationComponet.module.css"

const PagnationComponent = () => {
  return (
    <ul className={classes.pagnationList}>
        <li><button>Next</button></li>
        <li > <button className={classes.pageNum}>1</button></li>
        <li><button>prev</button></li>
    </ul>
  )
}

export default PagnationComponent